import {Component, inject} from '@angular/core';
import {LIST_OF_BANKS} from '../constants';
import {NewBankRequestComponent} from '../../../new-bank-request/new-bank-request';
import {BsModalService} from 'ngx-bootstrap/modal';
import {AuthenticationService} from '@auth/authentication.service';
import {LocalStorageService} from '@services/local-storage.service';
import {CurrentUserModel} from '@models/current-user.model';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {RouterModule} from '@angular/router';
import {LanguageSwitcher} from '@reusable/language-switcher/language-switcher';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {toSignal} from '@angular/core/rxjs-interop';
import {TaskCenterRealtimeService} from '../../../pages/task-center/task-center-realtime.service';

@Component({
  selector: 'app-client-header',
  templateUrl: './client-header.component.html',
  styleUrls: ['./client-header.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    LanguageSwitcher,
    BsDropdownModule,
  ]
})
export class ClientHeaderComponent {
  private readonly taskCenterRealtimeService = inject(TaskCenterRealtimeService);

  banksListUrl = LIST_OF_BANKS;
  currentUser: CurrentUserModel;
  readonly taskCenterEventCount = toSignal(this.taskCenterRealtimeService.taskCenterEventCount$, {initialValue: 0});

  constructor(
    private modalService: BsModalService,
    private localStorageService: LocalStorageService,
    private authenticationService: AuthenticationService,
  ) {
    this.currentUser = this.localStorageService.getCurrentUserDetails();
  }

  requestNewBank() {
    this.modalService.show(NewBankRequestComponent);
  }


  logout() {
    this.authenticationService.logout();
  }
}
